import _ from 'lodash';
import { useContext } from 'react';

import { ActionFormContext } from '../../context/ActionForm';
import { CustomerRequestContext } from '../../context/CustomerRequest';
import objectDiff from '../../utils/useLocalStorage/objectDiff';

// Saves checkout form customer info to session so it survives the form remounting after a failed checkout
const useCustomerInfoSync = () => {
  const { formRef } = useContext(ActionFormContext);
  const { customerInfo: sessionCustomerInfo, setCustomerInfo: setSessionCustomerInfo } = useContext(CustomerRequestContext);

  return () => {
    const formData = new FormData(formRef.current);

    const firstName = formData.get('firstName').toString();
    const lastName = formData.get('lastName').toString();
    const phone = formData.get('phone').toString();
    const email = formData.get('email').toString();

    const customerInfo = {
      firstName,
      lastName,
      phone,
      email,
    };

    const diff = objectDiff(customerInfo, sessionCustomerInfo?.customer);

    if (!_.isEmpty(diff)) {
      // If form data differs, update saved info
      setSessionCustomerInfo({
        ...sessionCustomerInfo,
        customer: customerInfo,
      });
    }
  };
};

export default useCustomerInfoSync;
